import axios from "axios";
// Create axios instance with default configuration
import { useUserInfoStore } from "@/models/userInfo";
const api = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_BASE_URL}/api`,
  // basePath: "/api",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token =
      typeof window !== "undefined" ? localStorage.getItem("token") : null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // if (response.data.code === 33) {
    //   // 需要重新登录
    //   if (typeof window !== "undefined") {
    //     const { logOut } = useUserInfoStore()
    //     api.post("/user/logout").then((res) => {
    //       if (res.data.code === 0) {
    //         logOut()
    //       }
    //       // console.log("🚀 ~ res:", res)
    //       // if (res.data.code === 0) {
    //       // 重试当前请求
    //       // return api(response.config);
    //       // }
    //     }).catch((err) => {
    //       console.log("🚀 ~ err:", err)
    //     })
    //   }
    // }
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      // if (typeof window !== "undefined") {
      //   localStorage.removeItem("token");
      //   window.location.href = "/login";
      // }
    }
    return Promise.reject(error);
  }
);

export default api;
